// extracted by mini-css-extract-plugin
export var banner = "_pq-0";
export var settingRow = "_pq-2";
export var titleIcon = "_pq-1";